import { Injectable } from "@angular/core";
import { UiArguments } from "@recore-solutions/nstar-lib";
import { CodeTableService } from "src/app/listing/code-table.service";
import { ListingService } from "./listing.service";
import { LoonFnFactoriesService } from "./loon-fn-factories.service";

@Injectable({ providedIn: "root" })
export class SchoolDistrictFnFactoriesService extends LoonFnFactoriesService {
	constructor(
		protected listingService: ListingService,
		protected codeTableService?: CodeTableService
	) {
		super(listingService, codeTableService);
	}

	queryTransformFn = (uiArguments: UiArguments) => {
		const children = this.getChildrenFromUiArguments(uiArguments);
		return (term, additionalParams) => {
			if (!!term && typeof term === "number") {
				return this.queryTransformByIdFn(
					term,
					uiArguments.uiComponent.databaseTable,
					uiArguments.uiComponent.databaseColumn
				);
			} else {
				if (!additionalParams?.every((a) => !!a)) {
					return null;
				}
				return this.reduceAdditionalParams(children, additionalParams);
			}
		};
	};

	searchFn = () => this.genericSearchFn("Polaris.spGetSchoolDistrictAPI");
}
